import { useDispatch } from 'react-redux'
import plusIcon from '../../assets/icons/plus.svg'
import Navbar from '../../components/Navbar/Navbar'
import styles from './ClientControlPage.module.css'
import { useAppSelector } from '../../redux/types/types'
import { getClients } from '../../redux/actions/clientsAction'
import { useEffect, useState } from 'react'
import LegalClientsTable from '../../components/LegalClientsTable/LegalClientsTable'
import IndividualClientsTable from '../../components/IndividualClientsTable/IndividualClientsTable'
import CreateClientModal from '../../components/CreateClientModal/CreateClientModal'
import CustomButton from '../../components/UI/CustomButton/CustomButton'
import { useNavigate } from 'react-router-dom'
import PATH from '../../navigation/path'
import { useMediaQuery } from 'react-responsive'

const ClientControlPage = () => {
  const dispatch = useDispatch()
  const { token } = useAppSelector((state) => state.auth)
  const { clients } = useAppSelector((state) => state.clients)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [clientType, setClientType] = useState('individual')
  const navigate = useNavigate()
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })
  useEffect(() => {
    if (!token) {
      navigate(PATH.authPage)
    }
  }, [])

  useEffect(() => {
    if (token) {
      dispatch(getClients({ token }) as any)
    }
  }, [dispatch, token])

  return (
    <div className={styles.clientControlPageContainer}>
      <Navbar />
      <div className={styles.clientControlPage}>
        <div className={styles.titleBlock}>
          Клиенты
          {isMobile && (
            <CustomButton
              title=''
              iconSrc={plusIcon}
              onClick={() => setIsModalOpen(!isModalOpen)}
            />
          )}
        </div>

        <div className={styles.mainFilters}>
          <div className={styles.leftSide}>
            <div className={styles.topButtons}>
              <button
                className={clientType == 'legal' ? styles.activeButton : ''}
                onClick={() => setClientType('legal')}
              >
                Юридические Лица
              </button>
              <button
                className={clientType == 'individual' ? styles.activeButton : ''}
                onClick={() => setClientType('individual')}
              >
                Физические лица
              </button>
            </div>
          </div>
          <div className={styles.rightSide}>
            {!isMobile && (
              <CustomButton title='Создать Клиента' onClick={() => setIsModalOpen(!isModalOpen)} />
            )}
          </div>
        </div>

        {clientType == 'legal' ? (
          <LegalClientsTable data={clients} />
        ) : (
          <IndividualClientsTable data={clients} />
        )}
      </div>
      <CreateClientModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(!isModalOpen)
        }}
      />
    </div>
  )
}

export default ClientControlPage
